import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ColorSwatch2 = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M14.4444 18C13.5014 18 12.5971 17.6254 11.9303 16.9586C11.2635 16.2918 10.8889 15.3874 10.8889 14.4444V3.77778C10.8889 3.30628 11.0762 2.8541 11.4096 2.5207C11.743 2.1873 12.1952 2 12.6667 2H16.2222C16.6937 2 17.1459 2.1873 17.4793 2.5207C17.8127 2.8541 18 3.30628 18 3.77778V14.4444C18 15.3874 17.6254 16.2918 16.9586 16.9586C16.2918 17.6254 15.3874 18 14.4444 18ZM14.4444 18H3.77778C3.30628 18 2.8541 17.8127 2.5207 17.4793C2.1873 17.1459 2 16.6937 2 16.2222V12.6667C2 12.1952 2.1873 11.743 2.5207 11.4096C2.8541 11.0762 3.30628 10.8889 3.77778 10.8889H5.82222M10.8889 5.86667L9.11111 4.08889C8.77773 3.75561 8.32562 3.56838 7.85422 3.56838C7.38282 3.56838 6.93071 3.75561 6.59733 4.08889L4.08355 6.60267C3.75027 6.93605 3.56305 7.38815 3.56305 7.85955C3.56305 8.33096 3.75027 8.78306 4.08355 9.11644L12.0836 17.1164M14.4444 14.4444V14.4533"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default ColorSwatch2
